import { Box, Tooltip, Typography } from '@mui/material';
import TextField from 'domains/core/components/TextField';

type Props = {
    name: string;
    handleNameChange: (name: string) => void;
    withClickAway?: boolean;
    disabled?: boolean;
};

const DISABLED_TOOLTIP_MESSAGE = "Curation name can't be changed";

const CustomCampaignNameInput = ({ name, handleNameChange, withClickAway, disabled }: Props) => {
    // When disabled with clickAway mode, show a static name display with tooltip
    if (disabled && withClickAway) {
        return (
            <Tooltip title={DISABLED_TOOLTIP_MESSAGE} arrow placement="bottom">
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '3.5rem',
                        cursor: 'not-allowed',
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {name}
                    </Typography>
                </Box>
            </Tooltip>
        );
    }

    // When disabled without clickAway, show disabled TextField with tooltip
    if (disabled) {
        return (
            <Tooltip title={DISABLED_TOOLTIP_MESSAGE} arrow placement="bottom">
                <Box sx={{ width: '100%' }}>
                    <TextField
                        counterCurrent={name.length ?? 0}
                        counterMax={255}
                        inputProps={{ maxLength: 255 }}
                        label="Name"
                        value={name}
                        width="100%"
                        withCounter
                        disabled
                    />
                </Box>
            </Tooltip>
        );
    }

    return (
        <TextField
            counterCurrent={name.length ?? 0}
            counterMax={255}
            inputProps={{ maxLength: 255 }}
            label="Name"
            value={name}
            width={withClickAway ? '50%' : '100%'}
            withClickAway={withClickAway}
            withCounter
            onChange={(e: any) => handleNameChange(e.target.value)}
        />
    );
};

export default CustomCampaignNameInput;
